import { FC, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useQueryCreateOrUpdateDiscipline } from 'Hooks/disciplines/useQueryCreateOrUpdateDiscipline';
import { IDisciplineRequest } from 'Data/interfaces/Obra/IDisciplineRequest';
import Modal from 'Components/UI/Modal';
import Button from 'Components/UI/Button';
import Field from 'Components/UI/Field';
import Form from 'Components/UI/Form/Form';
import { createSchema } from './cadastroDisciplina.schema';
import { ButtonsWrapper, DisciplinaWrapper } from './styles';

interface ICadastroDisciplina {
  visible?: boolean;
  id?: number;
  description?: string;
  constructionSiteId: number;
  onCancel: () => void;
}

const CadastroDisciplina: FC<ICadastroDisciplina> = ({
  visible,
  id,
  description,
  constructionSiteId,
  onCancel,
}) => {
  const { t } = useTranslation('disciplinas');
  const {createOrUpdateDisciplineAsync, isLoading} = useQueryCreateOrUpdateDiscipline();

  const schema = useMemo(() => createSchema(t), [t]);
  const [isSubmit, setIsSubmit] = useState(false);

  const submit = async (values: any) => {
    const discipline: IDisciplineRequest = {
      ConstructionSiteId: constructionSiteId,
      Name: values.description,
    };
    if (id) {
      discipline.Id = id;
    }
    await createOrUpdateDisciplineAsync(discipline);
    setIsSubmit(false);
    onCancel();
  };

  const buttons = (
    <ButtonsWrapper>
      <Button
        onClick={onCancel}
        type='text'
        className='buttonCancel'
      >
        {t('cadastroDisciplina.cancel')}
      </Button>
      <Button
        type='primary'
        htmlType='submit'
        onClick={() => setIsSubmit(true)}
        className='buttonSubmit'
        disabled={isLoading}
        loading={isLoading}
      >
        {t('cadastroDisciplina.confirm')}
      </Button>
    </ButtonsWrapper>
  );

  return (
    <Modal
      visible={visible}
      title={id ? t('cadastroDisciplina.titleEdit') : t('cadastroDisciplina.titleCreate')}
      footerButtons={buttons}
      footerActive={false}
      width={600}
      customClassName
      newHeader
      onCancel={onCancel}
      maskClosable={false}
    >
      <DisciplinaWrapper>
        <Form
          schema={schema}
          isSubmited={isSubmit}
          className='disciplinaForm'
          onSubmit={submit}
        >
          <Field
            label={t('cadastroDisciplina.fieldLabel')}
            name='description'
            className='inputDescription'
            defaultValue={description}
            disabled={isLoading}
          />
        </Form>
      </DisciplinaWrapper>
    </Modal>
  );
};

export default CadastroDisciplina;
